// extracted by mini-css-extract-plugin
export default {"container":"ER-z","error":"FR-z","disabled":"GR-z","submit":"HR-z","option":"IR-z","success":"JR-z","failure":"KR-z"};